import React from "react";
import styles from "./displayFields.module.css";

const DisplayFields = ({ values, fields, headers, singleColumn }) => {
  const midIndex = Math.ceil(fields.length / 2);
  const leftFields = fields.slice(0, midIndex);
  const rightFields = fields.slice(midIndex);

  return (
    <div
      className={`${styles.container} ${
        singleColumn ? styles["single-column"] : styles["multi-column"]
      }`}
    >
      {singleColumn ? (
        <div>
          <div className={styles["header-name"]}>{headers?.first}</div>
          {fields.map(({ id, label }) => (
            <div key={id} className={styles.field}>
              <div className={styles.label}>{label}:</div>
              <div className={styles.value}>{values[id]}</div>
            </div>
          ))}
        </div>
      ) : (
        <>
          <div>
            <div className={styles["header-name"]}>{headers?.first}</div>
            {leftFields.map(({ id, label }) => (
              <div key={id} className={styles.field}>
                <div className={styles.label}>{label}:</div>
                <div className={styles.value}>{values[id]}</div>
              </div>
            ))}
          </div>
          <div>
            <div className={styles["header-name"]}>{headers?.second}</div>
            {rightFields.map(({ id, label }) => (
              <div key={id} className={styles.field}>
                <div className={styles.label}>{label}:</div>
                <div className={styles.value}>{values[id]}</div>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default DisplayFields;
